import type {
  Fraction,
  WithName,
  WithValue,
} from "@aprao/common/src/shapes/common.js";
import { makeAutoObservable } from "mobx";

import { FractionHolderDelegate } from "./delegates/FractionHolderDelegate.js";
import { WithNameDelegate } from "./delegates/WithNameDelegate.js";

export class AmountNamedFacade {
  constructor(readonly $model: WithValue<Fraction> & WithName) {
    makeAutoObservable(this);
  }

  get named() {
    return new WithNameDelegate(this.$model);
  }

  get valueHolder() {
    return new FractionHolderDelegate(this.$model);
  }
}
